!function () {
    var _ = {};

    _.handleClick = function (click) {
        let $this = $(this);
        if (!$this.is('[disabled]')) {
            $this.addClass('clicked');
            setTimeout(() => { $this.removeClass('clicked'); }, 500);
            if (typeof click === 'function') {
                click.call(this);
            }
        }
    };

    window.buttons = _;
}();